module.exports = __webpack_public_path__ + "img/Desvincular-black.1da0f810.png";